<div class="container">

  <!--da configurare la reperibilità e visualizzazione dei salvataggi  -->
  <div calss="row">
   <div class="col-12">
    elenco salvatagi...
   </div>
   <br>
   <hr>
    <div
      class="col"
      role="button"
      (click)="goToLink(domain+'/Identity/Account/Manage')"
    >
    <button class="btn btn-primary"> vai ai dati personali</button>
    </div>
<!-- solo per test -->
    <br />
    userData
    <pre>{{ userData$  | json }}</pre>

    <br />

  </div>
</div>
